import React from 'react';
import './Inventory.css'

const Inventory = () => {
    return (
        <div>
            <h1>Inventory Page</h1>
        </div>
    );
};

export default Inventory;